var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-autocomplete",
    {
      attrs: {
        rounded: "",
        "open-on-focus": true,
        data: _vm.filteredData,
        field: _vm.filedFilter || _vm.pageFilters.selectedFilter,
        placeholder: _vm.placeHolder || _vm.$t("label.search_placeholder"),
        icon: "magnify",
        clearable: _vm.clearable || true
      },
      on: {
        select: function(option) {
          return _vm.handleSelect(option)
        }
      },
      model: {
        value: _vm.pageFilters.searchQuery,
        callback: function($$v) {
          _vm.$set(_vm.pageFilters, "searchQuery", $$v)
        },
        expression: "pageFilters.searchQuery"
      }
    },
    [
      _c("template", { slot: "empty" }, [
        _vm._v(_vm._s(_vm.$t("messages.data_not_found")))
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }